import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"px-4 py-2"},[_c(VCardTitle,[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c(VCardText,[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"primary","loading":_vm.loading},on:{"click":_vm.clickOk}},[_vm._v(" "+_vm._s(_vm.ok)+" ")]),_c(VBtn,{on:{"click":_vm.clickCancel}},[_vm._v(" "+_vm._s(_vm.cancel)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }